import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=774a083d&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774a083d')) {
      api.createRecord('774a083d', component.options)
    } else {
      api.reload('774a083d', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=774a083d&", function () {
      api.rerender('774a083d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JEOI2ILSftNn/JS/comp/IncreaseNumber.vue"
export default component.exports